import React, { useEffect, useState } from 'react'

import IncidentHighRiskContext from 'contexts/IncidentHighRiskContext'

import { history } from 'service'
import { routes } from 'Routes'

const IncidentHighRiskProvider = ({ children }) => {
  const [activeHighRiskStep, setActiveHighRiskStep] = useState(0)
  const [lastActiveHighRiskStep, setLastActiveHighRiskStep] = useState(0)
  const [wantsToAdvanceHighRiskStep, setWantsToAdvanceHighRiskStep] =
    useState(false)
  const [wantsToReturnHighRiskStep, setWantsToReturnHighRiskStep] =
    useState(false)
  const [activeButton, setActiveButton] = useState(true)
  const [showButtons, setShowButtons] = useState(true)

  const handleAdvanceHighRiskStep = () => {
    setWantsToAdvanceHighRiskStep(true)
  }

  const handleReturnHighRiskStep = () => {
    setWantsToReturnHighRiskStep(true)
  }

  const resetAdvanceHighRiskStep = () => {
    setWantsToAdvanceHighRiskStep(false)
  }

  const resetReturnHighRiskStep = () => {
    setWantsToReturnHighRiskStep(false)
  }

  const handleHighRiskNext = () => {
    setActiveHighRiskStep(
      (prevActiveHighRiskStep) => prevActiveHighRiskStep + 1,
    )
  }

  const handleHighRiskBack = () => {
    if (activeHighRiskStep === 0) return history.push(routes.incidents.all)

    setActiveHighRiskStep(
      (prevActiveHighRiskStep) => prevActiveHighRiskStep - 1,
    )
  }

  const handleHighRiskStep = (step) => {
    if (step > lastActiveHighRiskStep) return

    setActiveHighRiskStep(step)
  }

  const isHighRiskStepCompleted = (step) => {
    return lastActiveHighRiskStep > step
  }

  useEffect(() => {
    if (activeHighRiskStep > lastActiveHighRiskStep) {
      setLastActiveHighRiskStep(activeHighRiskStep)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeHighRiskStep])

  return (
    <IncidentHighRiskContext.Provider
      value={{
        activeButton,
        activeHighRiskStep,
        handleAdvanceHighRiskStep,
        handleHighRiskBack,
        handleHighRiskNext,
        handleReturnHighRiskStep,
        handleHighRiskStep,
        isHighRiskStepCompleted,
        resetAdvanceHighRiskStep,
        resetReturnHighRiskStep,
        setActiveButton,
        setActiveHighRiskStep,
        setShowButtons,
        showButtons,
        wantsToAdvanceHighRiskStep,
        wantsToReturnHighRiskStep,
      }}
    >
      {children}
    </IncidentHighRiskContext.Provider>
  )
}

export default IncidentHighRiskProvider
